import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import classes from "./UniCellLeft.styl";

export interface ILeft extends PropsWithChildren {}

const UniCellLeft: FC<ILeft> = ({ children }): JSX.Element => {
    return (
        <div className={classes.left} data-tsid="unicell-left-test-id">
            {children}
        </div>
    );
};

UniCellLeft.displayName = "UniCell.Left";

export default UniCellLeft;
